import './email-recipients-control.scss';
import EmailRecipientsControl, {
  EmailRecipientsPlaceholder,
} from './EmailRecipientsControl';

export default EmailRecipientsControl;
export { EmailRecipientsPlaceholder };
